import React, { Fragment, useEffect, useState, useContext } from 'react';
import SidebarMenu from './SidebarMenu';
import CustomizerContext from '../../_helper/Customizer';
import { MENUITEMS } from './Menu';
import Profile from './Profile';
import { Role } from '../../api/DataApis';






const SideBarLayout = (props) => {
  const { toggleIcon } = useContext(CustomizerContext);
  const [currentUrl] = useState(window.location.pathname);
  const [filteredMenu, setfilteredMenu ] = useState([]);
  const id = window.location.pathname.split('/').pop();
  const [leftArrow, setLeftArrow] = useState(false);
  const layout = id;
  const [width, setWidth] = useState(0);

   // This removes any quotes around the string

console.log("Role....", Role);

  // Function to handle window resize
  const handleResize = () => {
    setWidth(window.innerWidth - 500);
  };

  const [mainmenu, setMainMenu] = useState(MENUITEMS);
  const userData = JSON.parse(localStorage.getItem("userdata") || "{}"); // Parse safely
const  issuperAdmin = userData?.data?.is_super_admin;
// console.log("issuperAdmin", userData?.data?.is_super_admin);

console.log("typeofsuperadmin", issuperAdmin);
  // Function to handle scroll
  const handleScroll = () => {
    if (window.scrollY > 400) {
      document.querySelector('.main-navbar').className =
        'main-navbar hovered';
    } else {
      if (document.getElementById('main-navbar'))
        document.querySelector('.main-navbar').className = 'main-navbar';
    }
  };

  // Set active class for menu items
  const setNavActive = (item) => {
    MENUITEMS.map(menuItems => {
      menuItems.Items.filter(Items => {
        if (Items !== item) {
          Items.active = false;
          document.getElementById('bg-overlay1').classList.remove('active');
        }
        if (Items.children && Items.children.includes(item)) {
          Items.active = true;
        }
        if (Items.children) {
          Items.children.filter(submenuItems => {
            if (submenuItems.children && submenuItems.children.includes(item)) {
              Items.active = true;
              submenuItems.active = true;
              return true;
            } else {
              return false;
            }
          });
        }
        return Items;
      });
      return menuItems;
    });
    item.active = !item.active;
    setMainMenu({ mainmenu: MENUITEMS });
  };

  useEffect(() => {
    setLeftArrow(true);
    window.addEventListener('resize', handleResize);
    handleResize();

    const currentUrl = window.location.pathname;
    MENUITEMS.map(items => {
      items.Items.filter((Items) => {
        if (Items.path === currentUrl)
          setNavActive(Items);
        if (!Items.children) return false;
        Items.children.filter(subItems => {
          if (subItems.path === currentUrl)
            setNavActive(subItems);
          if (!subItems.children) return false;
          subItems.children.filter(subSubItems => {
            if (subSubItems.path === currentUrl) {
              setNavActive(subSubItems);
              return true;
            } else {
              return false;
            }
          });
          return subItems;
        });
        return Items;
      });
      return items;
    });

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, [layout, currentUrl]);

  // Close the overlay
  const closeOverlay = () => {
    document.getElementById('bg-overlay1').classList.remove('active');
    document.getElementById('nav-link').classList.remove('active');
  };

  // Retrieve the role from localStorage
  // const Role = "corporate";  // Normalize the role
// Get the role from localStorage and trim any extra spaces
console.log("Role", Role);
  // Filter out the "Corporate" menu item if the role is "corporate"
  const filteredMenuItems = MENUITEMS.map(menu => {
    // Only filter out the "Corporate" menu item if the role is "corporate"
    if (Role === "true") {
  
      menu.Items = menu.Items.filter(item => item.title !== 'Corporates');
    }
   if (issuperAdmin === "false") {
    const titlesToRemove = ['Placed Orders', 'Shippment Orders', 'Manual Orders'];
    menu.Items = menu.Items.filter(item => item.title !== 'Masters' && item?.title !== 'Shipment Management');
    menu.Items = menu.Items.map(item => ({
      ...item, // Keep all other properties of the item
      children: item.children?.filter(child => !titlesToRemove.includes(child.title)) || []
    }));
  }


    
    
    return menu;
  });
console.log("filteredMenuItems", filteredMenuItems);
  return (
    <Fragment>
      <div id="bg-overlay1" onClick={() => closeOverlay()}></div>
      <header className={`main-nav ${toggleIcon ? 'close_icon' : ''}`}>
        <Profile />
        <SidebarMenu 
          setMainMenu={setMainMenu} 
          props={props} 
          sidebartoogle={true} 
          setNavActive={setNavActive} 
          width={width} 
          menuItems={filteredMenuItems}  // Pass filtered menu items here
        />
      </header>
    </Fragment>
  );
};

export default SideBarLayout;
